// RESPONSIVE BG IMAGES
tetloose.imageR = function () {
    var $imageR = $('[rel=js-imageR], .js-imageR'),
        $mediaQuery = $window.width(),
        $mediaQuerySmall = '0',
        $mediaQueryMedium = '768',
        $mediaQueryLarge = '1024';

    function checkSize (elm, small, medium, large, isImg) {
        if ( $mediaQuery >= $mediaQueryLarge ) {
            if (isImg) {
                elm.attr('src', large );
            } else {
                elm.css('background-image', 'url(' + large + ')');
            }
        } else if ( $mediaQuery >= $mediaQueryMedium ) {
            if (isImg) {
                elm.attr('src', medium );
            } else {
                elm.css('background-image', 'url(' + medium + ')');
            }
        } else if ( $mediaQuery >= $mediaQuerySmall ) {
            if (isImg) {
                elm.attr('src', small );
            } else {
                elm.css('background-image', 'url(' + small + ')');
            }
        }
    }

    if ($imageR.length) {
        $imageR.each(function() {
            var $t = $(this),
                $small = $t.data('mobile'),
                $medium = $t.data('tablet'),
                $large = $t.data('desktop');

            if ( $t.is('img') ) {
                checkSize($t, $small, $medium, $large, true);
            } else {
                checkSize($t, $small, $medium, $large, false);
            }

        });
        $window.on('resize', function() {
            $mediaQuery = $window.width();
            $imageR.each(function() {
                var $t = $(this),
                    $small = $t.data('mobile'),
                    $medium = $t.data('tablet'),
                    $large = $t.data('desktop');

                if ( $t.is('img') ) {
                    checkSize($t, $small, $medium, $large, true);
                } else {
                    checkSize($t, $small, $medium, $large, false);
                }
            });
        });
    }
};
